import styled from 'styled-components';
import { Field, FieldConfig } from 'formik';
import { inputStyles } from './input';
import React, { InputHTMLAttributes } from 'react';

type Props = FieldConfig & Omit<InputHTMLAttributes<HTMLInputElement>, 'children'> & {
	unit?: string;
	setFieldValue?: any;
}

const StyledFormikField = styled(Field)`
  ${inputStyles};
  position: relative;
`;

const UnitInputWrapper = styled.div`
  position: relative;
  width: 100%;
`;

const UnitDisplay = styled.span`
  position: absolute;
  right: 1rem;
  top: 50%;
  transform: translateY(-50%);
  color: ${({theme}) => theme.colors.textColor};
  pointer-events: none;
	user-select: none;
`;

export const FormikFieldWithUnit: React.FC<Props> = ({ unit, ...props }) => (
	<UnitInputWrapper>
		<StyledFormikField {...props} unit={unit}/>
		{unit && <UnitDisplay>{unit}</UnitDisplay>}
	</UnitInputWrapper>
);
